import Component from "@bythepixel/component-loader";

const openClass = "modal--open";

export default class MicroModalAdaptor extends Component {
  static selector = "[data-comp-modal-trigger]";
  static loaderPriority = "in-view";

  constructor(...args) {
    super(...args);
    this.modalId = `${this.$container.dataset.compModalTrigger}-modal`;
    this.modalContainer = document.getElementById(this.modalId);
    this.isFacetedSearch = document.querySelector("[data-faceted-search]")
      ? true
      : false;

    if (!this.modalContainer) {
      console.warn(
        `[MicroModalAdaptor] Modal with id '${this.modalId} is not found.`
      );
      return;
    }

    this.modalController = null;
    this.modalCloseTriggers = this.modalContainer.querySelectorAll(
      "[data-comp-modal-close-trigger]"
    );
    this.modalContentContainer = this.modalContainer.querySelector(
      "[data-modal-content-container]"
    );
    this.modalContent = this.modalContainer.querySelector(
      "[data-modal-content]"
    );
    this.boundApplyHiddenStyles = () => this.applyHiddenStyles();
    sessionStorage.setItem(`modalStatus-${this.modalId}`, "closed");
    this.events();
  }

  async loadDependencies() {
    const module = await import("micromodal");
    this.modalController = module.default;
  }

  async show() {
    if (!this.modalController) await this.loadDependencies();

    this.modalController.show(this.modalId, {
      awaitCloseAnimation: true,
      disableScroll: true,
      openClass,
    });

    if (this.isFacetedSearch) {
      sessionStorage.setItem(`modalStatus-${this.modalId}`, "open");
    }
  }

  async close() {
    if (!this.modalController) await this.loadDependencies();
    this.modalController.close(this.modalId);
    this.modalContainer.addEventListener(
      "animationend",
      this.boundApplyHiddenStyles
    );

    if (this.isFacetedSearch) {
      sessionStorage.setItem(`modalStatus-${this.modalId}`, "closed");
    }
  }

  applyHiddenStyles() {
    this.modalContainer.removeEventListener(
      "animationend",
      this.boundApplyHiddenStyles
    );
    this.modalContainer.classList.remove(openClass);
  }

  events() {
    window.addEventListener("keepModalOpen", () => {
      if (
        this.isFacetedSearch &&
        sessionStorage.getItem(`modalStatus-${this.modalId}`) === "open"
      ) {
        this.show();
        const modalScrollPosition = sessionStorage.getItem(
          `modalScroll-${this.modalId}`
        );

        if (modalScrollPosition) {
          this.modalContentContainer.scrollTop = modalScrollPosition;
        }
      }
    });

    window.addEventListener("closeModal", () => {
      if (
        this.isFacetedSearch &&
        sessionStorage.getItem(`modalStatus-${this.modalId}`) === "open"
      ) {
        this.close();
      }
    });

    if (this.isFacetedSearch) {
      this.modalContentContainer.addEventListener("scroll", () => {
        requestAnimationFrame(() => {
          sessionStorage.setItem(
            `modalScroll-${this.modalId}`,
            this.modalContentContainer.scrollTop
          );
        });
      });
    }

    this.$container.addEventListener("click", () => this.show());
    this.modalCloseTriggers.forEach((el) =>
      el.addEventListener("click", () => this.close())
    );
    this.modalContent.addEventListener("click", (event) =>
      event.stopPropagation()
    ); // Prevent modal from closing when clicking inside the content
  }
}
